import { Injectable } from '@angular/core';
import { Http, Response } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/catch';
import { constant } from '../../app.constants';
import { ParentService } from '../../pages/A2-utils/ParentClass/ParentService';
import {
  GridLayoutDetail,
  GridLayoutMine,
  LayoutCommandResponse,
  PublicGridLayout,
  PublishLayoutRequest
} from './grid-layout-menu.interface';

@Injectable()
export class GridLayoutMenuService extends ParentService {

  constructor(private http: Http) {
    super();
  }

  getMine(moduleActionId: number): Observable<GridLayoutMine> {
    return this.http.get(constant.URL_LAYOUT_MINE + moduleActionId, this.getHeader())
      .map((res: Response) => res.json() as GridLayoutMine)
      .catch((error: Response) => Observable.throw(error.json()));
  }

  getPublic(moduleActionId: number, search?: string): Observable<PublicGridLayout[]> {
    let url = constant.URL_LAYOUT_PUBLIC + moduleActionId;
    const term = search ? search.trim() : '';
    if (term) {
      url += '?search=' + encodeURIComponent(term);
    }
    return this.http.get(url, this.getHeader())
      .map((res: Response) => res.json() as PublicGridLayout[])
      .catch((error: Response) => Observable.throw(error.json()));
  }

  getDetail(layoutId: number): Observable<GridLayoutDetail> {
    return this.http.get(constant.URL_LAYOUT_PUBLIC_DETAIL + layoutId, this.getHeader())
      .map((res: Response) => res.json() as GridLayoutDetail);
  }

  save(moduleActionId: number, config: string): Observable<LayoutCommandResponse> {
    const body = JSON.stringify({ moduleactionid: moduleActionId, config: config });
    return this.http.post(constant.URL_SAVE_LAYOUT, body, this.headerPost())
      .map((res: Response) => res.json() as LayoutCommandResponse)
      .catch((error: Response) => Observable.throw(error.json()));
  }

  publish(data: PublishLayoutRequest): Observable<LayoutCommandResponse> {
    const body = JSON.stringify({
      layoutid: data.layoutid,
      publicname: data.publicname
    });
    return this.http.put(constant.URL_LAYOUT_PUBLISH, body, this.headerPost())
      .map((res: Response) => res.json() as LayoutCommandResponse)
      .catch((error: Response) => Observable.throw(error.json()));
  }

  unpublish(layoutId: number): Observable<LayoutCommandResponse> {
    return this.http.put(constant.URL_LAYOUT_UNPUBLISH + layoutId, '{}', this.headerPost())
      .map((res: Response) => res.json() as LayoutCommandResponse)
      .catch((error: Response) => Observable.throw(error.json()));
  }

  apply(layoutId: number): Observable<GridLayoutDetail> {
    return this.http.post(constant.URL_LAYOUT_APPLY + layoutId, '{}', this.headerPost())
      .map((res: Response) => res.json() as GridLayoutDetail)
      .catch((error: Response) => Observable.throw(error.json()));
  }
}



// WEBPACK FOOTER //
// ./src/app/utils/grid-layout-menu/grid-layout-menu.service.ts